// Instantiate a loader
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader";
import {OBJLoader} from "three/examples/jsm/loaders/OBJLoader";
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import * as THREE from "three";

const fbxLoader = new FBXLoader();
const loader = new GLTFLoader();
// Optional: Provide a DRACOLoader instance to decode compressed mesh data
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath( '/examples/js/libs/draco/' );
loader.setDRACOLoader( dracoLoader );

// instantiate a loader
const objLoader = new OBJLoader();

export default class ThreeDLoader {
    static async loadGLTF(path){
        return new Promise((resolve, reject) => {

            // Load a glTF resource
            loader.load(
                // resource URL
                path, //'models/gltf/duck/duck.gltf',
                // called when the resource is loaded
                function ( gltf ) {

                    resolve(gltf);
                    /**
                    scene.add( gltf.scene );

                    gltf.animations; // Array<THREE.AnimationClip>
                    gltf.scene; // THREE.Group
                    gltf.scenes; // Array<THREE.Group>
                    gltf.cameras; // Array<THREE.Camera>
                    gltf.asset; // Object
                     **/
                },
                // called while loading is progressing
                function ( xhr ) {},
                // called when loading has errors
                function ( error ) {
                    console.log(error);
                    reject(error);
                }
            );
        })
    }
    static async loadObj(path){
        return new Promise((resolve, reject) => {
            // load a resource
            objLoader.load(
                // resource URL
                path, //'models/monster.obj',
                // called when resource is loaded
                function ( object ) {
                    resolve(object)
                },
                // called when loading is in progresses
                function ( xhr ) {},
                // called when loading has errors
                function ( error ) {
                    reject(error);
                }
            );
        })
    }
    static async loadFBX(path){
        return new Promise((resolve) => {
            fbxLoader.load(
                path,
                (object) => {
                    const mixer = new THREE.AnimationMixer(object)

                    object.animations.forEach(animation => {
                        mixer.clipAction(animation)
                    })
                    object.mixer = mixer;
                    resolve(object);
                },
                (xhr) => {},
                (error) => {console.log(error)}
            )
        })
    }
}

